import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1280px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <h1 className="text-xl md:text-2xl font-heading font-bold text-primary-500">
              汗汗漫画
            </h1>
            <span className="hidden sm:inline text-xs text-foreground-500 font-sans bg-background-100 px-2 py-0.5 rounded-full">
              韩漫免费阅读
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer hover:text-primary-500 ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 text-sm bg-background-100 border border-background-200 rounded-full px-4 py-1.5 pl-9 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/50 bg-background-50">
            <div className="flex flex-col py-3 px-4 gap-3 max-w-[1280px] mx-auto">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-medium whitespace-nowrap py-2 transition-colors cursor-pointer ${
                    location.pathname === link.to
                      ? 'text-primary-500'
                      : 'text-foreground-700'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="relative mt-1">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full text-sm bg-background-100 border border-background-200 rounded-full px-4 py-2 pl-9 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}